<template>
    <div v-if="text" class="info-message" :class="status" >
        <div class="wrapper">
            <div class="info-message__text" v-html="text" ></div>
        </div>
    </div>
</template>

<script>

let timeout;
export default {
    name : 'HeaderMessage',
    data : () => ({
        status : '',
        text : '',
    }),
    methods : {
        alert (text, status = 'success', delay = 3000) {
            clearTimeout(timeout);
            this.text = text;
            this.status = status;
            timeout = setTimeout(() => this.text = '', delay);
        },
    },
}
</script>
